import React, { Component, useContext, useEffect, useState } from 'react'
import CompleteOrderForm from '../../Components/CompleteOrderForm/CompleteOrderForm'

import "./AdminOrder.css"

import { useParams } from 'react-router-dom';
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import { getOrderAdminByID } from '../../Api/Orders';
import { Order } from '../../Models/Order';
import { PromiseSesionContext } from '../../Machines/ErrorMachine';
import SkeletonTitle from '../../Components/Skeleton/SkeletonTitle';
import SkeletonTag from '../../Components/Skeleton/SkeletonTag';
import { CustomTag } from '../../Components/Tags/CustomTag';
import { statusStyles } from '../../Components/Tags/TagConfig';
import SkeletonText from '../../Components/Skeleton/SkeletonText';
import { Flex } from 'antd';



const ManageOrder = ()=> {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState<boolean>(false);
  const [order, setOrder] = useState<Order>();
const {sendError} = useContext(PromiseSesionContext);

    const getProducts = async ()=>{
        try{
        setLoading(true);
        const response =  await getOrderAdminByID(id)

        setOrder(response)
        // setFilteredProducts(response.products); 

        setLoading(false);
        }
        catch(error){
        setLoading(false);
        sendError({type: "ERROR", data:{message:"Error al cargar la orden", type:"error"}})

        }
    }

    useEffect(() => {
        getProducts()
    }, []);
    
    return (
      <div className='ManageOrder-layout'>
        <div className='ManageOrder-header'>
            <Flex gap={"5px"} dir='row' align='center'>
                <SkeletonTitle loading={loading} >
                    <Title level={3} style={{margin:0}}>#ORDER-{order?.id}</Title>
                </SkeletonTitle>

                <SkeletonTag loading={loading}>
                    <CustomTag value={order?.status || ""} config={statusStyles} />
                </SkeletonTag>
                
            </Flex>
            <SkeletonText loading={loading}>
                <Text type='secondary'>{order?.createdAt}</Text>
            </SkeletonText>
        </div>


      </div>
    )
}

export default ManageOrder